import { Link } from 'react-router-dom';
import { getHotArticles } from '@/mocks/articles';

export default function HotNewsScroll() {
  const hotArticles = getHotArticles();

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="text-3xl md:text-4xl font-heading font-black text-foreground-950">
                今日<span className="text-primary-500">最热</span>
              </h2>
              <p className="text-sm text-foreground-500 mt-2">
                实时热度排行，吃瓜群众的今日必看
              </p>
            </div>
            <span className="hidden md:inline-flex items-center px-4 py-1.5 bg-foreground-950 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
              HOT
            </span>
          </div>

          <div className="flex gap-4 overflow-x-auto pb-4 -mr-4 md:-mr-6 scrollbar-hide"
            style={{ scrollSnapType: 'x mandatory' }}
          >
            {hotArticles.map((article, idx) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="flex-shrink-0 w-[260px] md:w-[300px] bg-background-50 rounded-xl overflow-hidden cursor-pointer group hover:bg-background-100 transition-colors"
                style={{ scrollSnapAlign: 'start' }}
              >
                <div className="relative h-[180px] md:h-[210px] overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.imageAlt}
                    title={article.imageAlt}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  {article.isExclusive && (
                    <span className="absolute top-3 left-3 px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded whitespace-nowrap">
                      独家
                    </span>
                  )}
                </div>
                <div className="p-4 flex items-start justify-between gap-3">
                  <div className="flex-1 min-w-0">
                    <p className="text-xs text-foreground-400 mb-1.5 whitespace-nowrap">
                      {article.publishDate}
                    </p>
                    <h3 className="text-sm font-medium text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-500 transition-colors">
                      {article.title}
                    </h3>
                  </div>
                  <span className="flex-shrink-0 text-2xl md:text-3xl font-heading font-black text-foreground-200">
                    {(idx + 1).toString().padStart(2, '0')}
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}